<template>
  <div :class="{'h-auto': !isAddFieldsPage}">
    <TitledProgressStepper
      v-if="steps"
      :steps="steps"
      v-on="$listeners"
    />

    <slot />
  </div>
</template>

<script setup>
// @ts-check
import { computed } from 'vue';
import { useRoute } from 'vue-router/composables';

import { TitledProgressStepper } from '@/components/library/progressSteppers/TitledProgressStepper';

/** @typedef {import('@/components/library/progressSteppers/TitledProgressStepper/TitledProgressStepper.vue').Step} Step */

defineProps({
  /** @type {import('vue').PropOptions<Step[]>} */
  steps: {
    type: Array,
    required: false,
  },
});

const route = useRoute();
// @TODO remove this hack to keep the height of the layout on the add fields page
const isAddFieldsPage = computed(() => route.name === 'EnvelopesStepAddFields');
</script>
